import { station3Slice } from './station3.slice.ts';

const { updateSelectedPost } = station3Slice.actions;

export const updateStationThreeSelectedPost = updateSelectedPost;
